export { default } from '@/components/Business/BusinessWorkPage';
